import { createFileRoute } from '@tanstack/react-router'
import DashboardIndexPage from '@/pages/dashboard/dashboard-index-page'

// Rota index para /dashboard/$dashboardId (rota exata)
// Esta rota será exibida quando acessar /dashboard/$dashboardId diretamente
export const Route = createFileRoute('/(dashboard)/dashboard/$dashboardId/')({
  component: function DashboardIndexRoute() {
    const { dashboardId } = Route.useParams()
    return <DashboardIndexPage dashboardId={dashboardId} />
  },
})
